// extracted by mini-css-extract-plugin
module.exports = {"ultrabold":"UltraBold_ultrabold__30eot"};